import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import HelmetWrapper from "../../../HelmetWrapper";
import MembershipTransferStructure from "../membership-transfer/MembershipTransferStructure";
import GymTransferStructure from "../gym-transfer/GymTransferStructure";

const TransferTabs = ({ userInfoData }) => {
  return (
    <HelmetWrapper title="WTF: Membership & Gym Transfer">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <div className="odm-tabs-new">
              <Tabs>
                <TabList>
                  <Tab>Membership Transfer</Tab>
                  <Tab>Gym Transfer</Tab>
                </TabList>

                <TabPanel>
                  <MembershipTransferStructure userInfoData={userInfoData} />
                </TabPanel>
                <TabPanel>
                  <GymTransferStructure userInfoData={userInfoData} />
                </TabPanel>
              </Tabs>
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default TransferTabs;
